module.exports = __webpack_public_path__ + "img/client-2.4c06d5b.png";